export default __webpack_public_path__ + "static/media/frg--walking-trails.b3fab0f4.png";